import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: `${environment.idmAuthURL}/realms/wsb`,
  redirectUri: window.location.origin,
  clientId: 'WOSM',
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
  requireHttps: false,
  strictDiscoveryDocumentValidation: false,
  skipIssuerCheck: true,
  disablePKCE: false,
  silentRefreshRedirectUri: window.location.origin + '/assets/silent-refresh.html',
  customQueryParams: {
    kc_idp_hint: 'oidc'
  },
  requestAccessToken: true,
  clearHashAfterLogin: true,
  oidc: true
}; 